import { useAuth } from "@/context/AuthContext";
import AdminTimesheets from "@/pages/admin/Timesheets";
import TimesheetOwnView from "@/components/TimesheetOwnView";

export default function TimesheetsRoute() {
  const { user } = useAuth();
  return user?.role === "admin" ? <AdminTimesheets /> : <TimesheetOwnView />;
}
